import { Injectable } from '@angular/core';
import { UserProvider } from './user';



@Injectable()
export class DataProvider {
  // Data Provider
  // This is the provider class for most of the Firebase observables in the app.

  constructor( public userProvider: UserProvider) {
    console.log("Initializing Data Provider");
  }

  // Get all users
  getUsers() {
    let ret: any;
    return ret;
  }

  // Get user with username
  getUserWithUsername(username) {
    let ret: any;
    return ret;
  }

  // Get logged in user data
  getCurrentUser() {
    let ret: any;
    return ret;
  }

  // Get user by their userId
  getUser(userId) {
    let ret: any;
    return ret;
  }

  // Get requests given the userId.
  getRequests(userId) {
    let ret: any;
    return ret;
  }

  // Get friend requests given the userId.
  getFriendRequests(userId) {
    let ret: any;
    return ret;
  }

  // Get conversation given the conversationId.
  getConversation(conversationId) {
    let ret: any;
    return ret;
  }

  // Get conversations of the current logged in user.
  getConversations() {
    let ret: any;
    return ret;
  }

  // Get messages of the conversation given the Id.
  getConversationMessages(conversationId) {
    let ret: any;
    return ret;
  }

  // Get messages of the group given the Id.
  getGroupMessages(groupId) {
    let ret: any;
    return ret;
  }

  // Get groups of the logged in user.
  getGroups() {
    let ret: any;
    return ret;
  }

  // Get group info given the groupId.
  getGroup(groupId) {
    let ret: any;
    return ret;
  }

  getBlockedLists(){
    let ret: any;
    return ret;
  }
}



// WEBPACK FOOTER //
// ./src/providers/data.ts